import React from 'react'

import { parseFacebookUrl, parseTwitterUrl } from '@common/functions'
import { MintButton } from '@common/library'
import { SVGArrowRight, SVGFacebook, SVGTwitter } from '@common/public/assets'
import AssetCarousel from '@components/AssetCarousel'
import LoadingSpinner from '@components/LoadingSpinner'
import useMain from '@hooks/useMain'
import useNetwork from '@hooks/useNetwork'
import useNetworkWallet from '@hooks/useNetworkWallet'
import {
    SuccessArticle,
    SuccessAssetContainer,
    SuccessFigure,
    SuccessHeader,
    SuccessLinks,
    SuccessNavigator,
    SuccessNavItem,
    SuccessNavItemLinkContainer,
    SuccessNavItemTitle,
    SuccessTitle,
} from '@styles/layouts/sucess/styles'

const Success: React.FC = () => {
    const {
        state: { metadataResults },
        operations: { reset: resetUseNetworkWallet },
    } = useNetworkWallet()
    const {
        operations: { reset: resetUseNetwork },
    } = useNetwork()
    const {
        state: {
            config,
            mainInit: { owner, blockchain, network, socialMedias, marketplaceUrl },
            transactionHash,
        },
        operations: { setCurrentStep, reset: resetUseMain },
    } = useMain()

    React.useEffect(() => {
        setCurrentStep('success')
    }, [])

    const [assetIndex, setAssetIndex] = React.useState(0)

    const handleMintAgain = React.useCallback(() => {
        resetUseNetworkWallet()
        resetUseNetwork()
        resetUseMain()
        localStorage.removeItem('walletconnect')
        setCurrentStep('home-multiple-sales-behaviour')
    }, [])

    const twitter = React.useMemo(() => {
        return socialMedias.find(media => media.title === 'twitter')
    }, [socialMedias])

    const facebook = React.useMemo(() => {
        return socialMedias.find(media => media.title === 'facebook')
    }, [socialMedias])

    if (metadataResults.length === 0) {
        return <LoadingSpinner />
    }
    console.log(assetIndex)

    return (
        <>
            <SuccessHeader>
                <SuccessTitle>{`Woo! You just minted ${metadataResults.length} NFT${
                    metadataResults.length > 1 ? 's' : ''
                }!`}</SuccessTitle>
            </SuccessHeader>
            <SuccessArticle>
                <SuccessAssetContainer>
                    <SuccessFigure>
                        <AssetCarousel setAssetIndex={setAssetIndex} metadataResults={metadataResults} owner={owner} />
                    </SuccessFigure>
                </SuccessAssetContainer>
                <SuccessNavigator>
                    <SuccessNavItem>
                        <SuccessNavItemTitle>Sell and Trade your NFTs</SuccessNavItemTitle>
                        <SuccessNavItemLinkContainer>
                            {marketplaceUrl.map((url, index) => (
                                <SuccessLinks
                                    key={`${index}-${url.title}`}
                                    href={url.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-href={url.title === 'facebook' ? url.link : null}
                                >
                                    <SVGArrowRight />
                                    {url.title}
                                </SuccessLinks>
                            ))}
                        </SuccessNavItemLinkContainer>
                    </SuccessNavItem>
                    <hr />
                    {socialMedias.length > 0 && (
                        <>
                            <SuccessNavItem>
                                <SuccessNavItemTitle>Share your new NFT!</SuccessNavItemTitle>
                                <SuccessNavItemLinkContainer>
                                    <div>
                                        {twitter && (
                                            <SuccessLinks
                                                href={parseTwitterUrl(twitter.text, twitter.link)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                socialMedia
                                            >
                                                <SVGTwitter />
                                            </SuccessLinks>
                                        )}
                                        {facebook && (
                                            <SuccessLinks
                                                href={parseFacebookUrl(facebook.text, facebook.link)}
                                                data-href={metadataResults[0].image}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                socialMedia
                                            >
                                                <SVGFacebook />
                                            </SuccessLinks>
                                        )}
                                    </div>
                                </SuccessNavItemLinkContainer>
                            </SuccessNavItem>
                            <hr />
                        </>
                    )}
                    {network === 'ethereum' && (
                        <SuccessNavItem>
                            <SuccessNavItemTitle>Transaction Confirmation</SuccessNavItemTitle>
                            <SuccessNavItemLinkContainer>
                                <SuccessLinks
                                    href={`${config.networks[network][blockchain].explorer_transaction}${transactionHash}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <SVGArrowRight />
                                    Etherscan
                                </SuccessLinks>
                            </SuccessNavItemLinkContainer>
                        </SuccessNavItem>
                    )}
                    <MintButton onClick={handleMintAgain}>Mint Another</MintButton>
                </SuccessNavigator>
            </SuccessArticle>
            {socialMedias.find(media => media.title === 'twitter') && (
                <script src="/src/common/widgets/twitter.js"></script>
            )}
            {socialMedias.find(media => media.title === 'facebook') && (
                <script src="/src/common/widgets/faceook.js"></script>
            )}
        </>
    )
}

export default Success
